import { render, staticRenderFns } from "./titlePage.html?vue&type=template&id=668cb39f&"
import script from "./titlePage.vue?vue&type=script&lang=js&"
export * from "./titlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports